const TOOL = {
  /**
   * @method: IsIos
   * @description: 是否为iPhone
   * @author: BrandBin
   * @update: 2020-10-10
   * @return {Object}
   */
  IsIos() {
    const ua = navigator.userAgent
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  },
  /**
   * @method: IsAndroid
   * @description: 是否为Android
   * @author: BrandBin
   * @update: 2020-10-10
   * @return {Object}
   */
  IsAndroid() {
    const ua = navigator.userAgent
    return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  },
  /**
   * @method: IsWechat
   * @description: 是否在Wechat内部浏览器
   * @author: BrandBin
   * @update: 2020-10-10
   * @return {Object}
   */
  IsWechat() {
    const ua = navigator.userAgent
    return ua.toLowerCase().indexOf('micromessenger') !== -1
  },
  /**
   * @method: WechatVersion
   * @description: 获取微信版本号
   * @author: BrandBin
   * @update: 2020-10-10
   * @return {Object}
   */
  WechatVersion() {
    return navigator.userAgent.match(/MicroMessenger\/([\d\\/.]+)/i)[1]
  },
  /**
   * @method: GetIosVersion
   * @description: 获取iphone系统版本号
   * @author: BrandBin
   * @update: 2020-10-10
   * @return {Object}
   */
  GetIosVersion() {
    const ua = navigator.userAgent.toLowerCase()
    const reg = /os [\d._]*/gi
    const info = ua.match(reg)
    const version = (info + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".")
    return version ? version : '0.0.0'
  },
  /**
   * @method: GetAndroidVersion
   * @description: 获取Android系统版本号
   * @author: BrandBin
   * @update: 2020-10-10
   * @return {Object}
   */
  GetAndroidVersion() {
    const ua = navigator.userAgent.toLowerCase()
    const match = ua.match(/android\s([0-9\\/.]*)/)
    return match ? match[1] : '0.0.0'
  },
  /**
   * @method: CompareVersion
   * @description: 版本号比较
   * @author: BrandBin
   * @update: 2020-10-10
   * @param {Object} params {curV: '当前版本号', reqV: 被比较版本号}
   * @return {Object} 如果curV 大于 reqV，则返回true，否则返回false
   */
  CompareVersion(curV, reqV) {
    const arr1 = curV.toString().split('.')
    const arr2 = reqV.toString().split('.')
    const minL = Math.min(arr1.length, arr2.length) //将两个版本号拆成数字
    let pos = 0 //当前比较位
    let diff = 0 //当前为位比较是否相等
    let flag = true
    // 逐个比较如果当前位相等则继续比较下一位
    while (pos < minL) {
      diff = parseInt(arr1[pos]) - parseInt(arr2[pos])
      if (diff === 0) {
        pos++
        continue
      } else if (diff > 0) {
        flag = true
        break
      } else {
        flag = false
        break
      }
    }
    return flag
  }
}

export {
  TOOL
}